import api, { ApiResponse, PageResponse } from './api'
import type { MerchantRefund } from '../types'

interface RefundListParams {
  page?: number
  size?: number
}

export function getRefunds(params: RefundListParams): Promise<ApiResponse<PageResponse<MerchantRefund>>> {
  return api.get('/v1/merchant/refunds', { params })
}
